function ensureProtocol(url: string) {
  if (!url) {
    return url;
  }

  if (!url.match(/^[a-zA-Z]+:\/\//)) {
    url = "http://" + url;
  }

  return url;
}

export default ensureProtocol;
